export default "__VITE_ASSET__c79306fc__"